export const LOADING_STATUS_INIT = 'LOADING_STATUS_INIT'
export const LOADING_STATUS_IN_PROGRESS = 'LOADING_STATUS_IN_PROGRESS'
export const LOADING_STATUS_SUCCESS = 'LOADING_STATUS_SUCCESS'
export const LOADING_STATUS_FAILURE = 'LOADING_STATUS_FAILURE'